<template>
    <TourLayout
        :config="config"
        show-skip-button
        @action-completed="onNotificationAction"
        @action-skipped="onSkipAction"
    >
        <NotificationsBlueprint />
    </TourLayout>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'
    import NotificationsBlueprint from '@/components/ui/NotificationsBlueprint.vue'
    import { useTourStore } from '@/stores/tour'
    import TourLayout from './TourLayout.vue'

    const emit = defineEmits(['action-skipped', 'action-completed'])

    const pushNotifications = usePushNotifications()
    const tourStore = useTourStore()

    const props = defineProps({
        config: Object,
    })

    const onNotificationAction = async () => {
        tourStore.handleAction(props.config.action_type, false)
        await pushNotifications.requestPermissionAndRegister()
        emit('action-completed', true)
    }

    const onSkipAction = () => {
        tourStore.handleAction(props.config.action_type, true)
        emit('action-skipped')
    }
</script>
